import { CheckoutEnvironment } from '@platform-frontend/checkout-drop-in';

export type ProductEnvironment = CheckoutEnvironment | 'DEMO';
